import { FormattedMessage } from 'react-intl';
import { Button, Icon } from '@ets/design-system';

import { useSelector } from '_common/hooks';
import { navigateToMyFiles } from 'router/history';

import { selectIsIEnvision } from 'App/redux/appSlice';

import { Logo } from '_common/components';
import AuthFooter from 'Auth/components/AuthFooter/AuthFooter';

import styles from './Error403.module.scss';

const Error403 = () => {
  const information = useSelector((state) => state.app.information);
  const isiEnvision = useSelector(selectIsIEnvision);
  const navigateToIEnvision = () => {
    if (information.extra) {
      window.location.href = `${information.extra.source}`;
    }
  };

  return (
    <div className={styles.root}>
      <Logo expanded size="small" testId="error403-logo" />
      <Icon
        style={{ margin: '5rem 0 3rem 0' }}
        color="primary"
        size="20"
        icon="lock"
        testId="error-403"
      />
      <div className={styles.message}>
        <FormattedMessage id="It seems you do not have permissions to see this page" />
      </div>
      <Button
        size="m"
        variant="primary"
        style={{ margin: '3rem 0 0 0' }}
        onClick={() => {
          isiEnvision ? navigateToIEnvision() : navigateToMyFiles(false, true);
        }}
        testId={`${isiEnvision ? 'back-to-ienvision' : 'back-to-your-space'}`}
      >
        <FormattedMessage id={isiEnvision ? 'BACK_TO_IENVISION' : 'errorView.clickToGoBack'} />
      </Button>
      <div className={styles.footer}>
        <AuthFooter white />
      </div>
    </div>
  );
};

export default Error403;
